import styled from 'styled-components';

const Description = styled.div`
  font-size: 16.67px;
  color: var(--grey);
  margin-bottom: 55px;
`;

export default Description;
